import { Routes } from '@angular/router';
import { CollaboraViewerComponent } from './pages/collabora-viewer/collabora-viewer.component';
import { collaboraCloseGuard } from './pages/collabora-viewer/collabora-close.guard';
import { MarkdownEditorComponent } from './pages/libraries/markdown-editor/markdown-editor.component';
import { VideoViewerComponent } from './pages/video-viewer/video-viewer.component';
import { authGuard, unauthGuard } from '@optima-stride-ai/optima-platform';
import { ApplicationShellComponent } from './application-shell/application-shell.component';
import { COMMON_ROUTES, COMMON_APP_CHILD_ROUTES } from '@optima-stride-ai/optima-app-framework';
import { Routes as AppRoutes } from './shared/enums/app-constants';
import { xappCapEmbedRedirectGuard } from './shared/guards/xapp-cap-embed-redirect-guard';



export const routes: Routes = [
      {
        path: AppRoutes.EMBED,
        loadComponent: () => import('./embed/hayagriva-document-embed.component').then(m => m.HayagrivaDocumentEmbedComponent),
        canActivate: [authGuard]
      },
      {
        path: '', 
        component: ApplicationShellComponent,
        canActivate: [xappCapEmbedRedirectGuard],
        children: [
          {path: '', redirectTo: 'dashboard', pathMatch: 'full' },
          { path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard-component/dashboard.component').then(m => m.HomeDashboardComponent), canActivate:[authGuard] },
          { path: 'libraries', loadChildren: () => import('./pages/libraries/routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'collabora-viewer', component: CollaboraViewerComponent, canActivate:[authGuard], canDeactivate: [collaboraCloseGuard] },
          { path: 'markdown-editor', component: MarkdownEditorComponent, canActivate:[authGuard]  },
          { path: 'video-viewer', component: VideoViewerComponent, canActivate:[authGuard]  },
          { path: 'documents/pdf', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard]  },
          { path: 'documents/doc', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/spreadsheet', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/presentation', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/markdown', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/diagrams', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/images', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/videos', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          { path: 'documents/templates', loadChildren: () => import('./pages/libraries/documet-routes').then(m => m.routes), canActivate:[authGuard] },
          ...COMMON_APP_CHILD_ROUTES
        ]
      },
      ...COMMON_ROUTES
];
